import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=42068fd4&"
import script from "./Loader.js?vue&type=script&lang=js&"
export * from "./Loader.js?vue&type=script&lang=js&"
import style0 from "./Loader.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports